import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h_clear",
  "use": "icon-h_clear-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h_clear\">\n  <g clip-path=\"url(#icon-h_clear_icon-4e9b9d1b7c11bad3)\">\n    <path d=\"M44.7818 24.1702L31.918 7.09935L14.1348 20.5L27.5 37L30.8556 34.6643L44.7818 24.1702Z\" fill=\"#7792FF\" stroke=\"#7792FF\" stroke-width=\"4\" stroke-linejoin=\"round\" />\n    <path d=\"M27.4998 37L23.6613 40.0748L13.0978 40.074L10.4973 36.6231L4.06543 28.0876L14.4998 20.2248\" stroke=\"#7792FF\" stroke-width=\"4\" stroke-linejoin=\"round\" />\n    <path d=\"M13.2056 40.072L44.5653 40.072\" stroke=\"#7792FF\" stroke-width=\"4\" stroke-linecap=\"round\" />\n  </g>\n  <defs>\n    <clipPath id=\"icon-h_clear_icon-4e9b9d1b7c11bad3\">\n      <rect width=\"48\" height=\"48\" fill=\"#FFF\" />\n    </clipPath>\n  </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/h_clear.svg
// module id = Rmt0
// module chunks = 102